import { DeviceEventSetupState } from "../types";
import {Reducer} from "redux";
import {
  deleteDeviceEventSetup,
  getCountries,
  getDeviceEventSetups,
  reset,
  saveDeviceEventSetup,
  setDeviceEventSetupModal
} from "../routines";
import DeviceEventSetup from "@Safemate/EventSetupNew/Model/DeviceEventSetup";
import { ModalEnum } from "@Safemate/EventSetupNew/Body/utils";
import { v4 } from "uuid";

const deviceEventSetupState: DeviceEventSetupState = {
  eventSetups: [],
  selectedEventSetup: null,
  modalType: ModalEnum.NONE,
  modalEventSetupIndex: 0,
  countries:[]
};

const deviceEventSetup: Reducer<DeviceEventSetupState> = (state: DeviceEventSetupState = deviceEventSetupState, action) => {
  switch (action.type) {

    case getDeviceEventSetups.SUCCESS:
      return {
        ...state,
        eventSetups: action.payload.sort((a: DeviceEventSetup, b: DeviceEventSetup) => {
          return a.sort - b.sort;
        }).map((eventSetup: DeviceEventSetup) => {
          return {
            ...eventSetup,
            localId: v4()
          }
        })
      }

    case deleteDeviceEventSetup.SUCCESS:
      return{
        ...state,
        eventSetups: action.payload.eventSetups.filter((setup: DeviceEventSetup) => setup.deviceEventSetupId !== action.payload.eventSetupId)
      }

    case getCountries.SUCCESS:
      return{
        ...state,
        countries: action.payload
      }

    case deleteDeviceEventSetup.FULFILL:
      return{
        ...state,
        modalType: ModalEnum.NONE,
        modalEventSetupIndex: 0,
        selectedEventSetup: null
      }

    case saveDeviceEventSetup.SUCCESS:
      return {
        ...state,
        eventSetups: action.payload
      }

    case setDeviceEventSetupModal.TRIGGER:
      return {
        ...state,
        ...action.payload
      }

    case reset.TRIGGER:
      return deviceEventSetupState;
    

    default:
      return state;
  }
};

export default deviceEventSetup;
